import MoreOptionsPopover from './MoreOptionsPopover';
import './MoreOptionsPopover.scss';

export default MoreOptionsPopover;
